module.exports = __webpack_public_path__ + "static/Starry eyed-Small-9e3ea210b010ee61c03a683422852d4e.png";